import { EGender } from 'affiny-core/modules/account/types';
import { IPosition } from 'affiny-core/modules/api/models/member/member.types';
import { PICTURE_FORMAT } from 'affiny-core/modules/pictures/types';

const I18N_BASE = 'compatibilityReport.graphs';

export const compatibilityTradMapper = {
  [EGender.FEMALE]: `${I18N_BASE}.her`,
  [EGender.MALE]: `${I18N_BASE}.him`,
  me: `${I18N_BASE}.me`,
};

export const VERTICAL_BAR_LENGTH = 180;
export const VERTICAL_BAR_THICKNESS = 6;
export const HORIZONTAL_BAR_THICKNESS = 6;
export const HORIZONTAL_BAR_VALUE_THICKNESS = 16;
export const HORIZONTAL_BAR_VALUE_MIN_LENGTH = 38;
export const AVATARS_DEFAULT_SIZE = 56;
export const AVATARS_FORMAT = PICTURE_FORMAT.SMALL;
export const AVATARS_OVERLAP_RATIO = 8 / AVATARS_DEFAULT_SIZE;

export const hasOverlappingDots = (
  myPosition: IPosition,
  otherPosition: IPosition
) => myPosition.x === otherPosition.x && myPosition.y === otherPosition.y;

export const computeVisionGraphLabels = (translationKeys: string[]) => ({
  titleTopLeft: `compatibilityReport.vision.graphLabels.${translationKeys[0]}`,
  titleTopRight: `compatibilityReport.vision.graphLabels.${translationKeys[1]}`,
  titleBottomLeft: `compatibilityReport.vision.graphLabels.${translationKeys[2]}`,
  titleBottomRight: `compatibilityReport.vision.graphLabels.${translationKeys[3]}`,
});
